// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".inspections__table th[data-v-7c838baf] {\n    white-space: nowrap;\n    padding-bottom: 1rem\n}\n.inspections__table td[data-v-7c838baf] {\n    white-space: nowrap;\n    padding-bottom: 1rem;\n    padding-right: 1rem\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
